/* globals window */
import { React, PT, connect, withRouter } from '@gasbuddy/react';
import fetch from 'isomorphic-fetch';
import UAParser from 'ua-parser-js';
import { Grid, Icon, Header, Segment, Button, Dimmer, Loader, Container, List, Popup, Message, Divider } from 'semantic-ui-react';
import {
  Auth, Nav, BasicInfo, RequestTable, InstrumentTable, TxTable, AuditTable, FeatureTable,
  CreditTable, CreditModal, ZdTable, ActionTable, NoteTable, ReferralTable, CouponsTable, TagTable,
} from '../../components';
import { Role } from '../../roles';
import { Action } from '../../reducers/actions';
import { AccountTools } from '../../devtools/AccountTools';
import { ProgramModal } from '../../components/payments/programModal';
import { MembershipInfo } from '../../components/payments/membershipInfo';
import { StatusModal } from '../../components/payments/statusModal';
import { StripeDeclinesModal } from '../../components/payments/stripeDeclinesModal';
import { BlockModal } from '../../components/payments/blockModal';
import { MembershipDiagnosticModal } from '../../components/identity/detail/MembershipDiagnosticModal';

function range(page) {
  return `Transactions ${(page * 5) + 1}-${(page + 1) * 5}`;
}

function deviceList(instruments) {
  if (!instruments || !instruments.length) {
    return [];
  }
  const uas = {};
  instruments.forEach((i) => {
    if (i.extra_data && i.extra_data.ua) {
      uas[i.extra_data.ua] = true;
    }
  });
  if (!Object.keys(uas).length) {
    return ['n/a'];
  }
  return Object.keys(uas).map((ua) => {
    if (/^okhttp/.test(ua) || /^GasBuddy Android/.test(ua)) {
      return ['Android App', ua];
    }
    const iosMatch = ua.match(/com.gasbuddymobile.gasbuddy.*build:([0-9.]+);/);
    if (iosMatch) {
      return [`iOS App ${iosMatch[1]}`, ua];
    }
    return [new UAParser(ua).getBrowser().name, ua];
  });
}

class BaseUserPage extends React.Component {
  state = {};

  componentDidMount() {
    this.doLookup();
  }

  componentWillReceiveProps(nextProps) {
    const { user: exUser, match: { params: { accountId } }, history } = this.props;
    const { user: nextUser, match: { params: { accountId: newAccountId } } } = nextProps;

    if (nextUser.account_id && String(nextUser.account_id) !== String(accountId)) {
      // URL has a non-account id (e.g. email) on it - we now know the
      // canonical id, so set the URL
      history.replace(`/identity/users/${nextUser.account_id}`);
    } else if (accountId !== newAccountId
      && (!Number.isSafeInteger(Number(newAccountId))
        || String(newAccountId) !== String(exUser.account_id))) {
      // URL has non-account on it and we already have a user,
      // must be they changed the target user
      this.doLookup(newAccountId);
    }
  }

  onNext = () => {
    const { user, dispatch, match } = this.props;
    dispatch({
      type: Action.Identity.User.TxPageRequested,
      meta: { apiAction: true },
      payload: {
        url: '/payments/transactions',
        body: {
          limit: 6,
          offset: ((user.txPage || 0) + 1) * 5,
          accountId: match.params.accountId,
        },
      },
    });
  }

  onPrev = () => {
    const { user, dispatch, match } = this.props;
    dispatch({
      type: Action.Identity.User.TxPageRequested,
      meta: { apiAction: true },
      payload: {
        url: '/payments/transactions',
        body: {
          limit: 6,
          offset: ((user.txPage || 0) - 1) * 5,
          accountId: match.params.accountId,
        },
      },
    });
  }

  superman = async () => {
    try {
      const { match: { params: { accountId: id } } } = this.props;
      const response = await fetch(`/identity/user/${id}/api-token`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Request-Source': 'ajax',
        },
        body: JSON.stringify({}),
      });
      const { access_token: at } = await response.json();
      this.setState({ access_token: at });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      this.setState({ access_token: error.message });
    }
  }

  doLookup = (forceAccountId) => {
    const { dispatch, match } = this.props;
    dispatch({
      type: Action.Identity.User.DetailRequested,
      meta: { apiAction: true },
      payload: {
        url: '/identity/user',
        body: { accountId: forceAccountId || match.params.accountId },
      },
    });
  }

  removeCard = async (accountId, cardId) => {
    await fetch(`/loyalty/clo/cards/${accountId}/${cardId}`, {
      credentials: 'include',
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Request-Source': 'ajax',
      },
    });
    this.doLookup();
  }

  toggleWexTx = () => {
    const { showWex } = this.state;
    this.setState({ showWex: !showWex });
  }

  render() {
    const { history, user: {
      account_id: accountId,
      guid,
      tripTakerGuids,
      loading,
      ident,
      tags,
      profile,
      requests,
      instruments,
      membership,
      referrals,
      coupons,
      audit,
      tx,
      txSummary,
      txPage,
      assignments,
      program,
      credits,
      tickets,
      actions,
      notes,
      annotations,
      linkedCards,
      deleteRequested,
    } } = this.props;
    const { access_token: accessToken, showWex } = this.state;
    return (
      <Auth forRoles={[Role.Superuser, Role.Users]}>
        <Nav>
          <Dimmer.Dimmable dimmed={loading}>
            <Dimmer active={loading}>
              <Loader />
            </Dimmer>
            <div>
              <Grid columns="equal">
                <Grid.Row stretched>
                  <Grid.Column>
                    <Header as="h3" block attached="top" style={{ flex: 0 }}>
                      Basic Information
                    </Header>
                    <Segment attached>
                      <BasicInfo
                        identifiers={ident}
                        profile={profile}
                        guid={guid}
                        tags={tags}
                        tripTakerGuids={tripTakerGuids}
                        id={Number(accountId || 0)}
                        deleteRequested={deleteRequested}
                        onUpdate={this.doLookup}
                      />
                    </Segment>
                  </Grid.Column>
                  <Auth forRoles={[Role.Superuser, Role.PaymentView]} hideUnauthorized>
                    <Grid.Column>
                      <Header as="h3" block attached="top" style={{ flex: 0 }}>
                        <StatusModal accountId={accountId} />
                        <BlockModal
                          onUpdate={this.doLookup}
                          accountId={accountId}
                          block={!!(annotations?.block)}
                          no_cc={!!(annotations?.no_cc)}
                          property_frozen={!!(annotations?.property_frozen)}
                          block_reason={annotations?.block_reason}
                        />
                        Payment Profile
                      </Header>
                      <Segment attached>
                        {annotations?.block && (
                          <Message error>Account Blocked From Payment Activity</Message>
                        )}
                        {annotations?.no_cc && (
                          <Message error>Account Blocked From Using CC</Message>
                        )}
                        {annotations?.property_frozen && (
                          <Message error>Account Property Frozen (OFAC)</Message>
                        )}
                        <InstrumentTable instruments={instruments} />
                      </Segment>
                      <Segment attached style={{ backgroundColor: 'rgb(243, 244, 245)' }}>
                        <ProgramModal accountId={accountId} onUpdate={this.doLookup} />
                        <b>Program</b>
:
                        {program && program.program_name}
                        <div />

                        {program?.extra_data?.partner && (
                          <div>
                            <Divider />
                            <b> Partner: </b>
                            {program.extra_data.partner.name}
                          </div>
                        )}
                        {program?.extra_data?.partner?.level && (
                          <div>
                            <b>Tier: </b>
                            {program.extra_data.partner.level}
                          </div>
                        )}
                        {program?.extra_data?.add_on && (
                          <div>
                            <b> Add on: </b>
                            {program.extra_data.add_on.qty}
                            &nbsp;
                            gallons
                            <b> @ </b>
                            $
                            {program.extra_data.add_on.amount}
                            <Divider />
                          </div>
                        )}
                      </Segment>

                      {!!membership && (
                        <React.Fragment>
                          <Header as="h3" block attached="top" style={{ flex: 0 }}>
                            <MembershipDiagnosticModal accountId={accountId} />
                            Membership Info
                          </Header>
                          <Segment attached>
                            <MembershipInfo
                              accountId={accountId}
                              program={program}
                              membership={membership}
                              instruments={instruments}
                              onUpdate={this.doLookup}
                            />
                          </Segment>
                        </React.Fragment>
                      )}

                      {referrals?.length ? (
                        <React.Fragment>
                          <Header as="h3" block attached="top" style={{ flex: 0 }}>
                            Referrals
                          </Header>
                          <Segment attached>
                            <ReferralTable accountId={accountId} referrals={referrals} />
                          </Segment>
                        </React.Fragment>
                      ) : null}

                      {linkedCards?.length ? (
                        <React.Fragment>
                          <Header as="h3" block attached="top" style={{ flex: 0 }}>
                            GasBack Linked Cards (CLO)
                          </Header>
                          <Segment attached>
                            <List divided>
                              {linkedCards.map(({
                                linked_card_id: cardId,
                                card_type: type,
                                tokenized_number: num,
                                groupon, empyr_id: emp,
                                rakuten_id: rak,
                                deleted_at: del,
                              }) => (
                                <List.Item style={{ textDecoration: del ? 'line-through' : 'none' }}>
                                  {`${type} ${num.substring(0, 4)}****${num.substring(num.length - 4)}`}
                                  {groupon && <img src="/logos/groupon.png" height="16" width="16" alt="groupon" style={{ marginLeft: 5 }} />}
                                  {rak && <img src="/logos/rakuten.png" height="16" width="16" alt="rakuten" style={{ marginLeft: 5 }} />}
                                  {emp && <img src="/logos/empyr.svg" height="16" width="48" alt="empyr" style={{ marginLeft: 5, backgroundColor: 'black' }} />}
                                  {!del && <Button size="tiny" color="red" floated="right" icon onClick={() => this.removeCard(accountId, cardId)}><Icon name="remove" /></Button>}
                                </List.Item>
                              ))}
                            </List>
                          </Segment>
                        </React.Fragment>
                      ) : null}

                      <Header as="h3" block attached="top" style={{ flex: 0 }}>
                        Devices
                      </Header>
                      <Segment attached>
                        <List>
                          {deviceList(instruments).map(([parsed, raw]) => (
                            <Popup
                              key={parsed}
                              content={raw}
                              trigger={<List.Item>{parsed}</List.Item>}
                            />
                          ))}
                        </List>
                      </Segment>
                    </Grid.Column>
                  </Auth>
                  <Grid.Column>
                    <Header as="h3" block attached="top" style={{ flex: 0 }}>
                      System Activity
                    </Header>
                    <Segment attached>
                      <RequestTable {...requests} />
                    </Segment>

                    <Auth forRoles={[Role.Superuser, Role.PaymentView]} hideUnauthorized>
                      <Header as="h3" block attached="top" style={{ flex: 0 }}>
                        Coupons
                      </Header>
                      <Segment attached>
                        <CouponsTable accountId={accountId} coupons={coupons} />
                      </Segment>
                    </Auth>
                  </Grid.Column>
                </Grid.Row>

                {(!!(tickets && tickets.results && tickets.results.length))
                  && (
                  <Grid.Row stretched>
                    <Grid.Column>
                      <Header as="h3" block attached="top" style={{ flex: 0 }}>
                        ZenDesk Tickets
                      </Header>
                      <Segment attached>
                        <ZdTable
                          tickets={tickets && tickets.results}
                          onSelected={t => window.open(t.url)}
                        />
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                  )
                }

                <Grid.Row stretched>
                  <Grid.Column>
                    <Header as="h3" block attached="top" style={{ flex: 0 }}>
                      <Button floated="right" size="mini" onClick={this.toggleWexTx}>{showWex ? 'Show Tx Amount' : 'Show Wex Amount'}</Button>
                      <StripeDeclinesModal accountId={accountId} />
                      <Button floated="right" size="mini" onClick={() => history.push(`/payments/transactions/search?account_id=${accountId}`)}>Search</Button>
                      Transaction Activity
                    </Header>
                    <Segment attached>
                      <TxTable
                        tx={tx}
                        txDetails={txSummary}
                        onNext={this.onNext}
                        onPrev={this.onPrev}
                        showPrevious={txPage > 0}
                        showWexSplit={!!showWex}
                        range={range(txPage || 0)}
                      />
                    </Segment>
                  </Grid.Column>

                  <Grid.Column>
                    <Header as="h3" block attached="top" style={{ flex: 0 }}>
                      Payment Audit Logs
                    </Header>
                    <Segment attached>
                      <AuditTable audit={audit} />
                    </Segment>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row stretched>
                  <Grid.Column>
                    <NoteTable notes={notes} type="identity" id={Number(accountId || 0)} />
                  </Grid.Column>

                  {assignments
                    && (
                    <Grid.Column>
                      <Header as="h3" block attached="top" style={{ flex: 0 }}>
                        Feature Assignments
                      </Header>
                      <Segment attached>
                        <FeatureTable assignments={assignments} />
                      </Segment>
                    </Grid.Column>
                    )
                  }
                </Grid.Row>

                <Grid.Row stretched>
                  <Grid.Column>
                    <Header as="h3" block attached="top" style={{ flex: 0 }}>
                      Action Log
                    </Header>
                    <Segment attached>
                      <ActionTable actions={actions} />
                    </Segment>
                  </Grid.Column>
                  {credits
                    && (
                    <Grid.Column>
                      <Header as="h3" block attached="top" style={{ flex: 0 }}>
                        Account Credit Transactions
                      </Header>
                      <Segment attached>
                        <CreditTable credits={credits} />
                        <Container fluid textAlign="right">
                          <CreditModal
                            accountId={Number(accountId || 0)}
                            onCredit={() => this.doLookup()}
                          />
                        </Container>
                      </Segment>
                    </Grid.Column>
                    )
                  }
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    <Header as="h3" block attached="top" style={{ flex: 0 }}>
                      Tags
                    </Header>
                    <Segment attached>
                      <TagTable tags={tags} />
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Auth forRoles={[Role.Superuser]} hideUnauthorized>
                <Segment inverted color="red">
                  <Button onClick={() => history.push(`/identity/users/${accountId}/wipe`)}>Wipe User Data</Button>
                  <Button onClick={this.superman}>Get API Token</Button>
                  {' '}
                  {accessToken}
                </Segment>
              </Auth>
              {process.env.NODE_ENV !== 'production'
                && <AccountTools accountId={accountId} email={ident?.find(i => i.name === 'email')?.identifier} firstName={profile?.find(p => p.uri === 'gb:contact')?.value?.first_name} lastName={profile?.find(p => p.uri === 'gb:contact')?.value?.last_name} />
              }
            </div>
          </Dimmer.Dimmable>
        </Nav>
      </Auth>
    );
  }
}

BaseUserPage.propTypes = {
  history: PT.shape({ replace: PT.func, push: PT.func }).isRequired,
  dispatch: PT.func.isRequired,
  match: PT.shape({
    params: PT.shape({
      accountId: PT.string,
    }),
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  user: PT.object.isRequired,
};

export const UserPage = withRouter(connect(({ user }) => ({ user }))(BaseUserPage));
